var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data != null)?_c('div',{ref:"agingStockBarChart",staticStyle:{"min-height":"400px"}}):_c('div',{staticStyle:{"min-height":"400px","display":"flex","align-items":"center","justify-content":"center"}},[_c('p',{staticStyle:{"margin":"0","font-size":"40px","text-shadow":"2px 2px 2px grey"}},[_vm._v("Loading...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }